const constants = {
  classes : {
    PRODUCT_BUYBOX: '.product-buybox',
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

$(document).ready(function () {
  // Initial page load, changing header style from a template.json file??

  /* For recharge invitation page */
  var element = document.querySelector(".user-customer");
  if (element) {
    document
      .querySelector("header")
      .classList.add("dark-header");
  }
  /* For recharge subscription page */
  var element = document.querySelector(".recharge-te");
  if (element) {
    document
      .querySelector("header")
      .classList.add("dark-header");
  }
  /* For captcha page */
  var element = document.querySelector(".shopify-challenge__container");
  if (element) {
    document
      .querySelector("header")
      .classList.add("dark-header");
  }

  /* For Influencer Shoutout */
  var element = document.getElementById("desktop-layout");
  if (element) {
    console.log("am i here")
    document
      .querySelector("header")
      .classList.add("dark-header");
  }
  

  /* MAIN COLLECTION PAGE */

  if ($("#page-collection-product-grid").length > 0) {
    $("header").addClass("static");

    document.querySelector("#MainContent").style.backgroundColor = "#dfeff9";
  }

  /* LOGIN */
  $('[id="page-login"] a[href="#recover"]').click(function () {
    $("#page-login").addClass("show-recovery");
  });
  $('[id="page-login"] a[href="#login"]').click(function () {
    $("#page-login").removeClass("show-recovery");
  });

  /* SUBSCRIPTION */
  if ($("#page-subscription").length > 0) {
    $("header").addClass("static");

    const skus = {
      peachy: "42480012853504",
      breezy: "42480012820736",
      royal: "42480012886272",
    };

    // START supporting functions
    const changeStepNumber = () => {
      const el = $("#page-subscription #step-number");
      switch (window.location.hash) {
        case "#step2":
          el.text("Step 2");
          break;
        // case "#step3":
        //   el.text("Step 3");
        //   break;
        default:
          el.text("Step 1");
      }
    };
    const changeTitle = () => {
      const el = $("#page-subscription #step-title");
      switch (window.location.hash) {
        case "#step2":
          el.text("How often do you shave?");
          break;
        // case "#step3":
        //   el.text("Never run out of blades");
        //   break;
        default:
          el.text("Which color do you fancy?");
      }
    };
    const changeDescription = () => {
      const el = $("#page-subscription #step-description");
      switch (window.location.hash) {
        case "#step2":
          el.html(
            "Change, delay or cancel at any time under your account, totally up to you! <br/> We will send reminder one week before shipping. "
          );
          break;
        // case "#step3":
        //   el.text("Review the plan:");
        //   break;
        default:
          el.text("");
      }
    };
    const changeLabels = () => {
      const el1 = $("#page-subscription #label-1 .label-description");
      const el2 = $("#page-subscription #label-2 .label-description");
      const el3 = $("#page-subscription #label-3 .label-description");
      const el4 = $("#page-subscription #label-4 .label-description");
      switch (window.location.hash) {
        case "#step2":
          el1.text("Deliver 4 blades once a month");
          el2.text("Deliver 4 blades every two months");
          el3.text("Deliver 4 blades every four months");
          el4.text("Deliver 4 blades every six months");
          break;
        default:
          el1.text("");
          el2.text("");
          el3.text("");
          el4.text("");
      }
    };
    const changeButton = () => {
      const el = $("#page-subscription #next-button");
      switch (window.location.hash) {
        case "#step2":
          el.text("Add to Cart");
          el.addClass("add-to-cart");
          break;
        default:
          el.text("Next");
          el.removeClass("add-to-cart");
      }
    };
    const changeConfirmationText = () => {
      const el = $("#page-subscription .confirmation-text p");
      let length = "month";
      if ($.cookie("subscription_frequency") == 1) length = "2 months";
      if ($.cookie("subscription_frequency") == 2) length = "4 months";
      if ($.cookie("subscription_frequency") == 3) length = "6 months";

      let text = "";
      switch (window.location.hash) {
        case "#step1":
          if ($.cookie("subscription_variant_id") == skus.peachy)
            text = "Oh so Peachy of a choice!";
          if ($.cookie("subscription_variant_id") == skus.breezy)
            text = "It's getting breezy in here!";
          if ($.cookie("subscription_variant_id") == skus.royal)
            text = "You're made for ROYALty!";
          el.text(text);
          break;
        // case "#step2":
        //   el.text(`Nice! We'll see you every ${length}`);
        //   break;
        case "#step2":
          el.text(`Nice! You got 4 blades coming every ${length}`);
          break;
        default:
          el.text("");
      }
    };
    const changeContent = () => {
      changeStepNumber();
      changeTitle();
      changeDescription();
      // changeLabels();
      changeButton();
      changeConfirmationText();
    };
    // END supporting functions

    // START Initial load check if cookies exist
    // const urlParams = new URLSearchParams(window.location.search);
    if ($.cookie("subscription_variant_id")) {
      $(
        `#page-subscription input:radio[value="${$.cookie(
          "subscription_variant_id"
        )}"]`
      ).prop("checked", true);
      changeContent();
      $("#page-subscription #next-button").show();
    }
    if ($.cookie("subscription_frequency")) {
      $(
        `#page-subscription input:radio[value="${$.cookie(
          "subscription_frequency"
        )}"]`
      ).prop("checked", true);
      changeContent();
      $("#page-subscription #next-button").show();
    }
    if (window.location.hash)
      $(`#page-subscription`).attr("data-hash", window.location.hash);
    if (!window.location.hash) window.location.hash = "#step1";
    if (window.location.hash == "#null") window.location.hash = "#step1";
    // END initial load

    // START url hash listening
    $(window).on("hashchange", function () {
      $(`#page-subscription`).attr("data-hash", window.location.hash);
      changeContent();

      // This prevents the page from scrolling down to where it was previously.
      if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
      }
      // This is needed if the user scrolls down during page load and you want to make sure the page is scrolled to the top once it's fully loaded. This has Cross-browser support.
      window.scrollTo(0, 0);
    });
    // END url hash listening

    // START button change listening
    $("#page-subscription input:radio[name=variant]").change(function () {
      $.cookie("subscription_variant_id", $(this).val());
      changeContent();

      $("#page-subscription #next-button").show();
    });
    $("#page-subscription input:radio[name=frequency]").change(function () {
      $.cookie("subscription_frequency", $(this).val());
      changeContent();

      // START supporting functions
      const changeStepNumber = () => {
        const el = $("#page-subscription #step-number");
        switch (window.location.hash) {
          case "#step2":
            el.text("Step 2");
            break;
          // case "#step3":
          //   el.text("Step 3");
          //   break;
          default:
            el.text("Step 1");
        }
      };
      const changeTitle = () => {
        const el = $("#page-subscription #step-title");
        switch (window.location.hash) {
          case "#step2":
            el.text("How often do you shave?");
            break;
          // case "#step3":
          //   el.text("Never run out of blades");
          //   break;
          default:
            el.text("Which color do you fancy?");
        }
      };
      const changeDescription = () => {
        const el = $("#page-subscription #step-description");
        switch (window.location.hash) {
          case "#step2":
            el.html(
              "Change, delay or cancel at any time under your account, totally up to you! <br/> We will send reminder one week before shipping. "
            );
            break;
          // case "#step3":
          //   el.text("Review the plan:");
          //   break;
          default:
            el.text("");
        }
      };
      const changeLabels = () => {
        const el1 = $("#page-subscription #label-1 .label-description");
        const el2 = $("#page-subscription #label-2 .label-description");
        const el3 = $("#page-subscription #label-3 .label-description");
        const el4 = $("#page-subscription #label-4 .label-description");
        switch (window.location.hash) {
          case "#step2":
            el1.text("Deliver 4 blades once a month");
            el2.text("Deliver 4 blades every two months");
            el3.text("Deliver 4 blades every four months");
            el4.text("Deliver 4 blades every six months");
            break;
          default:
            el1.text("");
            el2.text("");
            el3.text("");
            el4.text("");
        }
      };
      const changeButton = () => {
        const el = $("#page-subscription #next-button");
        switch (window.location.hash) {
          case "#step2":
            el.text("Add to Cart");
            el.addClass("add-to-cart");
            break;
          default:
            el.text("Next");
            el.removeClass("add-to-cart");
        }
      };
      const changeConfirmationText = () => {
        const el = $("#page-subscription .confirmation-text p");
        let length = "month";
        if ($.cookie("subscription_frequency") == 1) length = "2 months";
        if ($.cookie("subscription_frequency") == 2) length = "4 months";
        if ($.cookie("subscription_frequency") == 3) length = "6 months";

        let text = "";
        switch (window.location.hash) {
          case "#step1":
            if ($.cookie("subscription_variant_id") == skus.peachy)
              text = "Oh so Peachy of a choice!";
            if ($.cookie("subscription_variant_id") == skus.breezy)
              text = "It's getting breezy in here!";
            if ($.cookie("subscription_variant_id") == skus.royal)
              text = "You're made for ROYALty!";
            el.text(text);
            break;
          // case "#step2":
          //   el.text(`Nice! We'll see you every ${length}`);
          //   break;
          case "#step2":
            el.text(`Nice! You got 4 blades coming every ${length}`);
            break;
          default:
            el.text("");
        }
      };
      const changeContent = () => {
        changeStepNumber();
        changeTitle();
        changeDescription();
        // changeLabels();
        changeButton();
        changeConfirmationText();
      };
      // END supporting functions

      // START Initial load check if cookies exist
      // const urlParams = new URLSearchParams(window.location.search);
      if ($.cookie("subscription_variant_id")) {
        $(
          `#page-subscription input:radio[value="${$.cookie(
            "subscription_variant_id"
          )}"]`
        ).prop("checked", true);
        changeContent();
        $("#page-subscription #next-button").show();
      }

      if (currentStep != "#step2" && nextStep == "#null") {
        window.location.hash = "#step1";
        return;
      }

      if (currentStep == "#step1") nextStep = "#step2";
      // if (currentStep == "#step2") nextStep = "#step3";

      $(`#page-subscription`).attr("data-hash", nextStep);
      window.location.hash = nextStep;
      e.preventDefault();

      changeContent;
    });

    function addItemToCart() {
      const product = JSON.parse($("#productJSON").html());
      const plan =
        product.selling_plan_groups[0].selling_plans[
          $.cookie("subscription_frequency")
        ].id;

      data = {
        id: $.cookie("subscription_variant_id"),
        quantity: 1,
        selling_plan: plan,
      };
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          window.location.href = "/cart";
        },
      });
    }
  }

  class Capitalize {
    constructor() {
    }

    variantTitle(title) {
      if (title == null) return  ''

      const words = title.split("-");

      for (let i = 0; i < words.length; i++) {
          words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }

      words.join(" ");

      return words.join(" ")
    }
  }

  class MobileMenu {
    constructor() {
      this.menuOpen = false;
      this.mobileMenuClose = $("[mobile-menu-close]");
      this.mobileMenuTrigger = $("[mobile-menu-trigger]");
      this.initialize();
    }
  
    initialize() {
      this.mobileMenuClose.click(() => this.toggleMobileMenu());
      this.mobileMenuTrigger.click(() => this.toggleMobileMenu());
    }
  
    toggleMobileMenu() {
      if (this.menuOpen) {
        $("body").css({ overflow: "initial" });
        $("#mobile-menu").css({ display: "none", marginTop: 0 });
        $("#menu-open").removeClass("hidden")
        $("#menu-close").addClass("hidden")
        this.menuOpen = false;
        return;
      }
  
      $("body").css({ overflow: "hidden" });
      $("#menu-open").addClass("hidden")
      $("#menu-close").removeClass("hidden")

      if ($("header").hasClass("header-fixed"))
        $("#mobile-menu").css({ display: "block", marginTop: 69 });
      else 
        $("#mobile-menu").css({ display: "block", marginTop: 113 });
  
      this.menuOpen = true;
    }
  }
  new MobileMenu()

  class Backdrop {
    show(openedFrom) {
      $("body").css({ overflow: "hidden" })
      $(`
        <div
          class="z-20 fixed w-full h-full bg-neutral-500 opacity-40 top-0"
          data-backdropfor="${openedFrom}"
          backdrop
        ></div>
      `).insertBefore(`.${openedFrom}`)
    }

    hide(backdropfor) {
      $(`[data-backdropfor="${backdropfor}"]`).remove()
      $("body").css({ overflow: "initial" });
    }
  }
  class Modal {
    constructor() {
      this.backdrop = new Backdrop()
      this.initialize();
    }

    open(e) {
      const { modal } = e.currentTarget.dataset
      this.backdrop.show('modal')
      $(`#${modal}`).removeClass('hidden');
    }

    close(e) {
      this.backdrop.hide('modal')
      $(e.target).closest('[modal]').addClass('hidden');
    }

    initialize() {
      $(document).on("click", "[modal-open]", (e) => {
        e.preventDefault()
        this.open(e)
      })
      $(document).on("click", "[modal-close]", (e) => {
        e.preventDefault()
        this.close(e)
      })
    }
  }
  class BladesSellingPlan {
    constructor() {
      this.rechargeAppId = "294517"
      this.backorderAppId = "timesact"
    }

    renderSubscriptionUI(plan) {
      return `
      <div class="bg-white p-4 rounded-2xl mt-4 relative">
        <input id="flyout_frequency_subscription" type="checkbox" name="frequency" class="absolute opacity-0 w-8 h-8 cursor-pointer" />
        <div class="bg-white float-left border-2 rounded-md border-fuchsia w-8 h-8 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-fuchsia">
          <svg class="fill-current hidden w-3 h-3 text-fuchsia pointer-events-none" version="1.1" viewBox="0 0 17 12" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
              <g transform="translate(-9 -11)" fill="#fc0345" fill-rule="nonzero">
                <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
              </g>
            </g>
          </svg>
        </div>
        <label for="flyout_frequency_subscription" class="flex cursor-pointer text-md">
          Add a refill razor blade subscription?
        </label>
        <div class="subscription_frequency hidden">
          <div class='flex items-center mt-4'>
            <p class="m-0 pr-4">Deliver a 4-Pack every</p> 
            <select name="subscription_frequency" class="bg-gray-50 border border-fuchsia text-black text-sm rounded-md p-2.5">    
              <option value="${plan[0].id}">1 Month</option>
              <option value="${plan[1].id}">2 Months</option>
              <option value="${plan[2].id}">4 Months</option>
              <option value="${plan[3].id}">6 Months</option>
            </select>
          </div>
          <div modal-open data-modal="subscription-modal" class='flex items-center mt-4 cursor-pointer'>
            <img data-src='//www.hifreya.com/cdn/shop/t/26/assets/recharge_icon_small.png?v=135039636793210795951689354443' alt='Subscription information' class='mr-2 w-4 lazyload' />
            <span class="text-sm">Subscription Details</span>
          </div>
        </div>
      </div>`
    }

    renderBackorderUI(plan) {
      return `<div class="bg-white p-4 rounded-2xl mt-4"><p class="m-0 pr-4 backorder-text">${plan.name}</p></div>`
    }

    init(product) {
      let sellingPlan = {
        content: undefined,
        type: undefined
      }

      if (!product.selling_plan_groups.length) return sellingPlan

      product.selling_plan_groups.map(group => {
        // TODO: keep below code for future backorder direction
        // if (group.app_id == this.backorderAppId && 0 >= this.inventory){
        //   sellingPlan = {
        //     content: this.renderBackorderUI(group.selling_plans[0]),
        //     initialSubscriptionId: group.selling_plans[0].id,
        //     type: 'backorder'
        //   }
        // }
        // if (group.app_id == this.rechargeAppId && this.inventory >= 1)
        if (group.app_id == this.rechargeAppId)
          sellingPlan = {
            content: this.renderSubscriptionUI(group.selling_plans),
            initialSubscriptionId: group.selling_plans[0].id,
            type: 'subscription'
          }
      })

      return sellingPlan
    }
  }

  class CartUpsell {
    constructor() {
      this.bladesSellingPlan = new BladesSellingPlan()
      this.inventory = [
        Number(window.products.blades0inventory),
        Number(window.products.blades1inventory)
      ]
    }
  
    renderCartUpsellItem(item, upsellAttribute) {
      let variant = item.variants[0]

      let image = item.featured_image
      if (variant.featured_image) image = variant.featured_image.src

      // Custom attributes for backend data analytics
      // to track orders where upsells were added
      const cartData = JSON.stringify({ attributes: { Upsell: upsellAttribute } });

      let sellingPlan
      let initalSellingPlanId = ''
      if (upsellAttribute == 'Refill') {
        sellingPlan = this.bladesSellingPlan.init(item)
        
        if (sellingPlan.type != 'subscription' && sellingPlan.initialSubscriptionId != undefined)
          initalSellingPlanId = `data-selling_plan='${sellingPlan.initialSubscriptionId}'`
      }

      let variants = ``
      let hasSellableVariants = false
      if (item.variants)
      variants = `<div class="">
        <p class="text-sm m-0">Pick Your Blade Style</p>
        <select name="variant_upsell_selection" class="bg-gray-50 border border-fuchsia text-black rounded-md p-2.5">
          ${item.variants.map((variant, index) => {
            if (this.inventory[index] <= 0) return
            hasSellableVariants = true

            let title = variant.title
            if (variant.title == 'silky-white') title = 'Silky White for thicker hair'
            if (variant.title == 'harmony-grey') title = 'Harmony Grey for thinner hair'

            return `<option value="${variant.id}">${title}</option>`
          })}
        </select>
      </div>`

      let content = `
      <div class="product">
        <div class="flex">
          <div class="w-[90px] mr-5">
            <img
              class="w-auto lazyload"
              data-src="${image}"
              alt="${item.title}"
              style="max-height: 100px"
            />
          </div>
          <div class="flex flex-1 gap-8">
            <div class="flex flex-1 flex-col">
              <div class="flex flex-row justify-between mb-4">
                <p class="text-md m-0 mr-3">${item.title}</p>
                <p cart-item-price class="text-md m-0 mr-3">
                  <span class="original-price">${Shopify.formatMoney(
                    item.price
                  )}</span>
                </p>
              </div>
              ${variants}
            </div>
          </div>
        </div>
        ${sellingPlan.content && sellingPlan.content}
        <div class="pt-5 text-right">
          <button add-to-cart data-id="${variant.id}" data-cart='${cartData}' ${initalSellingPlanId} class="button min-w-fit min-h-fit bg-fuchsia  text-white">
            + Add to cart
          </button>
        </div>
      </div>`;
  
      if (!hasSellableVariants) return undefined
      return content;
    }
  
    /**
     * 
     * @param cart 
     * @returns null
     * Upsell is initialized when the flyout cart is fetched
     * the cart object is passed in as a parameter allowing to
     * inspected whether we are showing upsell or not
     */
    init(cart) {
      let hasShaver = false;
      let hasRefill = false;

      cart.items.map((item) => {
        if (item.handle == "starter-kit") hasShaver = true;
        if (item.handle == "4-refill-blades-pack") hasRefill = true;
      });

      // Show refill
      if (hasShaver && !hasRefill) {
        const content = this.renderCartUpsellItem(window.products.blades, "Refill")
        if (!content) return

        $("#upsell-product").html(content);
        $("#cart-upsell").removeClass("hidden");
        return;
      }
  
      // Show kit
      // if (!hasShaver && hasRefill) {
      //   $("#upsell-product").html(this.renderCartUpsellItem(kits, "Kit"));
      //   $("#cart-upsell").removeClass("hidden");
      //   return;
      // }
  
      // If no option is shown, make sure it's hidden
      $("#cart-upsell").addClass("hidden");
      hasShaver = false;
      hasRefill = false;
    }
  }
  class ShoppingCart {
    constructor() {
      this.cartDrawerContent = $("[cart-drawer-content]");
      this.cartDrawerClose = $("[cart-drawer-close]");
      this.cartDrawerTrigger = $("[cart-drawer-trigger]");
      this.cartSubtotal = $("[cart-subtotal]");
      this.cartIconQty = $("[cart-icon-qty]");
      this.backdrop = new Backdrop()
      this.bladesSellingPlan = new BladesSellingPlan()
      this.cartUpsell = new CartUpsell()
      this.capitalize = new Capitalize()
  
      this.initializeListeners();
    }
  
    closeShoppingCart() {
      this.backdrop.hide('cart')
      $("body").css({ overflow: "initial" });
      $("#cart").css({ right: $(window).width() > 768 ? "-450px" : "-350px" });
      $("#cart-footer").css({
        right: $(window).width() > 768 ? "-450px" : "-350px",
      });
    }
  
    openShoppingCart() {
      this.backdrop.show('cart')
      $("body").css({ overflow: "hidden" });
      $("#cart").css({ right: 0 });
      $("#cart-footer").css({ right: 0 });
    }
  
    fetchCart() {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: (cart) => {
          this.renderCart(cart);
          this.updateCartGlobals(cart);
        },
      });
    }

    fetchAndOpenCart() {
      this.fetchCart();
      this.openShoppingCart();
    }
  
    updateCart(data) {
      $.post(window.Shopify.routes.root + "cart/update.js", data);
    }
  
    async getVariant(variantId) {
      try {
        const response = await fetch(`/variants/${variantId}.json`, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        });
        const variant = await response.json();
  
        return variant.product_variant;
      } catch (err) {
        return null;
      }
    }
  
    renderSubscriptionItem({ key, title, image, sellingPlanFrequency, variantTitle }) {
      return `
        <div data-key="${key}" class="w-[90px] mr-5">
          <img
            class="h-auto lazyload"
            data-src="${image}"
            style="max-width: 90px"
          />
        </div>
        <div class="flex flex-col">
          <p class="text-md m-0">${title}</p>
          <p class="text-gray text-sm m-0">${this.capitalize.variantTitle(variantTitle)}</p>
          <p class="text-gray text-sm m-0">Ships every ${sellingPlanFrequency} for $9.99</p>
        </div>
      </div>`;
    }
  
    renderCartItem({ item, sellingPlan }) {
      let content = `
        <div class="w-[90px] mr-5">
          <img
            class="h-auto lazyload"
            data-src="${item.featured_image.url}"
            alt="${item.featured_image.alt}"
            style="max-width: 90px"
          />
        </div>
      <div class="flex flex-1 flex-col">
        <div class="flex">
          <p class="flex-1 m-0 text-md">${item.product_title}</p>
          <p cart-item-price data-key="${item.key}" class="m-0">`;
  
        if (item.original_line_price != item.final_line_price)
          content += `
            <span class="text-sale sale-price">
              ${Shopify.formatMoney(item.final_line_price)}
            </span>
            <span class="line-through original-price">
              ${Shopify.formatMoney(item.original_line_price)}
            </span>
          `;
        else content += `<span class="original-price">${Shopify.formatMoney(
          item.original_line_price
        )}</span>`;
  
      content += `
          </p>
        </div>
        <p class="text-gray">`;
  
        item.variant_options.map(option => {
          if (option == 'Default Title') return
          content += `${this.capitalize.variantTitle(option)}<br />`;
        })

        if (sellingPlan && sellingPlan.id == '3438477568')
          content += `${sellingPlan.name}<br />`;

      content += `
        </p>`;
  
      content += `
          <div class="flex flex-1 items-end">
            <div class="flex w-full items-center">
              <div class="flex-1">
                <div class="quantity">
                  <button
                    cart-qty-decrease
                    data-key="${item.key}"
                    class="quantity__button"
                    name="minus"
                    type="button"
                  >-</button>
                  <input
                    disabled
                    cart-qty-input
                    data-key="${item.key}"
                    class="quantity__input"
                    type="number"
                    value="${item.quantity}"
                  />
                  <button
                    cart-qty-increase
                    data-key="${item.key}"
                    class="quantity__button"
                    name="plus"
                    type="button"
                  >+</button>
                </div>
              </div>
              <p
                remove-from-cart
                data-key="${item.key}"
                class="underline caption pb-[2px] cursor-pointer"
              >
                Remove
              </p>
            </div>
          </div>
        `;
  
      content += `</div>`;
  
      return content;
    }

    renderEmptyCart() {
      this.cartDrawerContent.html(`
        <div class='text-center'>
          <h3 class='m-0 mt-12'>Your Cart Is Empty</h3>
          <p>Let's fix that.</p>
          <a href='/products/starter-kit#breezy' class='button secondary'>Shop our best razor</a>
        </div>
       `);
    }
  
    async renderCart(cart) {
      this.cartUpsell.init(cart);
  
      if (cart.items.length === 0) {
        this.renderEmptyCart();
        document.getElementById("cart-footer").classList.add("hidden");
        return;
      }
  
      document.getElementById("cart-footer").classList.remove("hidden");
  
      let content = "";
      cart.items.map((item, index) => {

        let sellingPlan
        if (item.selling_plan_allocation) sellingPlan = item.selling_plan_allocation.selling_plan

        content += `<div cart-item data-key="${item.key}" data-sku="${item.sku}" data-id="${item.id}" class="${
          cart.items.length != index ? "border-b" : ""
        }">
          <div class="flex p-5">` + (this.renderCartItem({ item, sellingPlan })) + `</div>`;
          
        if (sellingPlan && sellingPlan.id != '3438477568') // Backorder ID
          content += `
              <div class="flex p-5 bg-breezy">
                ` +
            (this.renderSubscriptionItem(
              // Do we have a refill object, or a starter kit object?
              item.handle == "4-refill-blades-pack" ? {
                title: item.product_title,
                image: item.image,
                key: item.key,
                sellingPlanFrequency: item.selling_plan_allocation.selling_plan.name.split("every ")[1],
                variantTitle: item.variant_title

              } : {
                title: '4-Pack Blade Refill',
                image: "https://www.hifreya.com/cdn/shop/files/4REFILLharmony-greyfront_30894c82-e268-4a98-bbd3-56fc87746504.png?v=1701055813",
                key: item.key,
                sellingPlanFrequency: item.selling_plan_allocation.selling_plan.name.split("every ")[1],
                variantTitle: 'Harmony Grey'
              })) +
            `
              </div>
            `;
        content += `
        </div>
        `;
      })
  
      this.cartDrawerContent.html(content);
    }
  
    cartUi(action, { cart, id, quantity }) {
      const item = cart.items.filter((item) => item.key == id)[0];
  
      switch (action) {
        case "remove":
          $(`[cart-item][data-key="${id}"]`).remove();
          break;
        case "updateQty":
          $(`[cart-qty-input][data-key="${id}"]`).val(quantity);
          $(`[cart-item-price][data-key="${id}"] .sale-price`).html(
            Shopify.formatMoney(item.final_line_price)
          );
  
          // TODO: INCOMPLETE- BREAKS WHEN NO SALE
  
          // if (item.discounted_price) {
          //   const variant = await this.getVariant(item.id)
  
          //   const price = Number(variant.compare_at_price) > 0 ? Number(variant.compare_at_price.replace('.','')) * item.quantity : item.original_line_price
  
          //   $(`[cart-item-price][data-key="${id}"] .original-price`).html(
          //     Shopify.formatMoney(price)
          //   );
          // } else
          $(`[cart-item-price][data-key="${id}"] .original-price`).html(
            Shopify.formatMoney(item.original_line_price)
          );
          break;
      }
  
      this.updateCartGlobals(cart);
    }
  
    updateCartGlobals(cart) {
      this.cartSubtotal.html(Shopify.formatMoney(cart.items_subtotal_price));
      this.cartIconQty.html(cart.item_count);
    }
  
    initializeListeners() {
      $(document).on("click", '[add-to-cart]', (e) => {
        e.preventDefault();

        let { cart, id, selling_plan, properties } = e.target.dataset;

        if (e.target.dataset.cart) cart = JSON.parse(e.target.dataset.cart);

        let cartData = {}
        let items = {}
        // Do we have a top level cart object being passed in?
        if (cart) cartData = cart
        // DO we have an individual item being passed in?
        if (id) items = [{ id, quantity: 1, selling_plan: selling_plan ? selling_plan : undefined, properties: properties ? JSON.parse(properties) : undefined }]
        
        // If we have both, merge them
        cartData = {...cartData, items: cartData.items ?  [...cartData.items, ...items] : items}

        console.log('cartData',cartData)

        $.post(
          "/cart/add.js",
          cartData,
          () => {
            this.openShoppingCart();
            this.fetchCart();
          },
          "json"
        );
      });

      $(document).on("click", "[cart-qty-increase]", (e) => {
        const id = $(e.target).data("key");
        const quantity = Number($(e.target).siblings("input").val()) + 1;
  
        $.post(
          "/cart/change.js",
          {
            quantity,
            id,
          },
          (cart) => {
            this.cartUi("updateQty", { cart, id, quantity });
          },
          "json"
        );
      });
  
      $(document).on("click", "[cart-qty-decrease]", (e) => {
        const id = $(e.target).data("key");
        const quantity = Number($(e.target).siblings("input").val()) - 1;
        $.post(
          "/cart/change.js",
          {
            quantity,
            id,
          },
          (cart) => {
            if (quantity == 0) this.cartUi("remove", { cart, id });
            else this.cartUi("updateQty", { cart, id, quantity });
          },
          "json"
        );
      });
  
      $(document).on("click", "[remove-from-cart]", (e) => {
        const id = $(e.target).data("key");
        $.post(
          "/cart/change.js",
          {
            quantity: 0,
            id,
          },
          (cart) => {
            this.cartUi("remove", { cart, id });
          },
          "json"
        );
      });
  
      this.cartDrawerClose.click(() => this.closeShoppingCart());
  
      this.cartDrawerTrigger.click(() => {
        this.fetchCart();
        this.openShoppingCart();
      });
    }
  }

  /**
   * After all classes are done, let's listen for any clicks
   * directly on the backdrop and do a failsafe close
   */
  const shoppingCart = new ShoppingCart()
  const modal = new Modal()
  const backdrop = new Backdrop()
  $(document).on("click", "[backdrop]", function (e) {
    e.preventDefault()
    const { backdropfor } = e.currentTarget.dataset

    backdrop.hide(backdropfor)

    if (backdropfor == 'cart')
      shoppingCart.closeShoppingCart()

    if (backdropfor == 'modal')
      modal.close(e)
  });

  if (window.location.pathname == '/cart') {
    shoppingCart.fetchAndOpenCart()
  }

  /**
   * Global subscription add to cart either from PDP or Shopping Cart
   */
  $(document).on("change", '[name="frequency"]', (e) => {
    const buttonEl = e.target.closest(constants.classes.PRODUCT_BUYBOX).querySelector('[add-to-cart]')
    const subscriptionContainerEl = e.target.closest(constants.classes.PRODUCT_BUYBOX).querySelector('.subscription_frequency')

    if (e.target.checked == true) {
      buttonEl.dataset.selling_plan = e.target.closest(constants.classes.PRODUCT_BUYBOX).querySelector('[name="subscription_frequency"]').value;
      subscriptionContainerEl.classList.remove('hidden')
    }
    else {
      delete buttonEl.dataset.selling_plan;
      subscriptionContainerEl.classList.add('hidden')
    }
  })
  
  $(document).on('change', '[name="subscription_frequency"]', function (e) {
    e.target.closest(constants.classes.PRODUCT_BUYBOX).querySelector('[add-to-cart]').dataset.selling_plan = e.target.value;
  });

  $(document).on('change', '[name="variant_upsell_selection"]', function (e) {
    const el = e.target.closest(constants.classes.PRODUCT_BUYBOX)
    const upsellItem = window.products.blades.variants.filter(variant => variant.id == e.target.value)[0]

    el.querySelector('img').dataset.src = upsellItem.featured_image.src;
    el.querySelector('img').src = upsellItem.featured_image.src;
    el.querySelector('[add-to-cart]').dataset.id = e.target.value;
  });
});

(function influencerModal() {
  performance.getEntriesByType("navigation")
    .forEach((p, i) => {
      if(p.redirectCount == 1) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'RqLbQk']);
      }
    });
})()